// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners_wrapper__Ck5I-","row":"Partners_row__wuUxD","column":"Partners_column__JO2MI"};